import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UrlValidatorService } from '../../core/services/url-validator.service';
import { map } from 'rxjs/operators';

@Injectable()
export class CertificationTrackerService {

    baseURL = environment.API_URL;
    serviceBase = this.baseURL + '/api/adminDashboard';
    queryString: string;

    constructor(private http: HttpClient, private urlValidator: UrlValidatorService) { }

    getAllMasters(selectedLanguage: string) {
        const sanitizedSelectedLanguage = this.urlValidator.sanitizeParam(selectedLanguage);
        const params = new HttpParams().set('selectedLanguage', sanitizedSelectedLanguage);
        return this.http.get<any>(this.serviceBase + '/getAllMasters', { params });
    };

    getProjectCountStatusWise(searchCriteria, selectedLanguage: string) {
        this.queryString = '/getProjectCountStatusWise?selectedLanguage=' + selectedLanguage;
        return this.http.post<any>(this.serviceBase + this.queryString, searchCriteria);
    }

    GetProjectCertifierWiseCount(searchCriteria, selectedLanguage: string) {
        this.queryString = '/GetProjectCertifierWiseCount?selectedLanguage=' + selectedLanguage;
        return this.http.post<any>(this.serviceBase + this.queryString, searchCriteria);
    }

    GetProjectCountryWiseCount(searchCriteria, selectedLanguage: string) {
        this.queryString = '/GetProjectCountryWiseCount?selectedLanguage=' + selectedLanguage;
        return this.http.post<any>(this.serviceBase + this.queryString, searchCriteria);
    }

    GetProjectStatusDataCount(searchCriteria, selectedLanguage: string) {
        this.queryString = '/GetProjectStatusDataCount?selectedLanguage=' + selectedLanguage;
        return this.http.post<any>(this.serviceBase + this.queryString, searchCriteria);
    }

    GetProjectBuildingTypeCount(searchCriteria, selectedLanguage: string) {
        this.queryString = '/GetProjectBuildingTypeCount?selectedLanguage=' + selectedLanguage;
        return this.http.post<any>(this.serviceBase + this.queryString, searchCriteria);
    }

    getCertificationTrackerProjects(searchCriteria) {
        this.queryString = '/getCertificationTrackerData';
        return this.http.post<any>(this.serviceBase + this.queryString, searchCriteria)
            .pipe(
                map((data: any[]) => {
                    if (!Array.isArray(data)) { return data; }
                    return data.map(item => ({
                        ...item,
                        showPreCertDownload: !!(item && item.preCertDataId),
                        showPostCertDownload: !!(item && item.postCertDataId)
                    }));
                })
            );
    }

    exportExpressedInterestProjectsToExcel() {
        this.queryString = '/exportExpressedInterestProjectsToExcel';
        return this.http.post(this.serviceBase + this.queryString, null);
    }

    exportExpressedInterestProjectsToExcelForCountryAdmin() {
        this.queryString = '/exportExpressedInterestProjectsToExcelForCountryAdmin';
        return this.http.post(this.serviceBase + this.queryString, null);
    }

    exportSubprojectsToExcel(searchCriteria) {
        this.queryString = '/exportProjectsToExcel';
        return this.http.post(this.serviceBase + this.queryString, searchCriteria);
    }

    downloadProjectCertificate(certificateId, toolName) {
        this.queryString = '/downloadProjectCertificate?projectDataCertificateId=' + certificateId + '&toolName=' + toolName;
        return this.http.get(this.serviceBase + this.queryString, { responseType: 'blob', observe: 'response' });
    }
}
